import { render, staticRenderFns } from "./List.vue?vue&type=template&id=4f25b82a"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=4f25b82a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f25b82a')) {
      api.createRecord('4f25b82a', component.options)
    } else {
      api.reload('4f25b82a', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=4f25b82a", function () {
      api.rerender('4f25b82a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/DataList/List.vue"
export default component.exports